module.exports = __webpack_public_path__ + "img/icon_check.6104ea32.svg";